import React, { useState } from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { SidebarData } from './SidebarData';
import './MenuButton.css';
import { IconContext } from 'react-icons';

function MenuButton() {
  const [sidebar, setSidebar] = useState(false);

  // const showSidebar = () => setSidebar(!sidebar);

  const showSidebar = () => {
    if (window.innerWidth < 1200) {
      // showSidebar(false);
      setSidebar(!sidebar);
      SidebarData.map((val,key) => {
        return <li key={key} className='row' id={window.location.pathname == val.link ? "active" : ""} onClick={()=> {window.location.pathname = val.link}}>
            {" "}
            <div id='title6'>
                {val.title}
            </div>
            </li>;
    })
    } else {
      showSidebar(true);
    }
  };

  return (
    <>
      <IconContext.Provider value={{ color: '#000000' }}>
        <div className='navbar1'>
          <Link to='#' className='menu-bars'>
            <FaIcons.FaBars onClick={showSidebar} />
          </Link>
        </div>
        <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>
          <ul className='nav-menu-items' onClick={showSidebar}>
            <li className='navbar-toggle'>
              <Link to='#' className='menu-bars'>
                <AiIcons.AiOutlineClose id='x-button'/>
              </Link>
            </li>
            {SidebarData.map((item, index) => {
              return (
                <li key={index} className={item.cName}>
                  <Link to={item.path}>
                    {item.icon}
                    <span>{item.title}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </IconContext.Provider>
    </>
  );
}

export default MenuButton;